import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import {
  BorderRadius,
  Breakpoint,
  FontSize,
  FontWeight,
  FONT_STACK,
  RESET_IOS_INPUT_STYLE,
  SHADOW,
  STANDARD_TRANSITION,
} from '../../../styles/constants';
import { propSwitch } from '../../../util/propSwitch';

export const FilterTextInput = styled.input`
  ${STANDARD_TRANSITION};
  ${RESET_IOS_INPUT_STYLE};
  ${FONT_STACK}
  background: none;
  border: none;
  box-sizing: border-box;
  color: ${ThemeColours.black};
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.REGULAR};
  height: 100%;
  outline: 0;
  overflow: hidden;
  padding-left: 48px;
  padding-right: 50px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  &:hover {
    border: none;
  }

  &:focus {
    background: ${ThemeColours.white};
    border: none;
    border-radius: 24px;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${ThemeColours.mono600};
    font-size: ${FontSize.REGULAR};
  }

  ${Breakpoint.SMALL} {
    color: ${ThemeColours.mono900};
  }
`;

export const LocationList = styled.ul`
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 19px;
  margin: 16px 0 0;
  padding: 0;
`;

export const LoadingWrapper = styled.div`
  background: ${ThemeColours.white};
  border-radius: none;
  box-sizing: border-box;
  left: 0;
  min-height: 100vh;
  padding: 10px;
  position: fixed;
  top: 70px;
  width: 100%;

  ${Breakpoint.SMALL} {
    border-radius: 10px;
    min-height: unset;
    position: absolute;
    top: 80px;
    width: 400px;
  }
`;

export const LocationListContainer = styled.div`
  background: ${ThemeColours.white};
  border-radius: none;
  box-shadow: none;
  left: 0;
  max-height: 100vh;
  min-height: 100vh;
  overflow: auto;
  padding: 24px 0px 0px 24px;
  position: fixed;
  top: 70px;
  width: 100%;

  ${Breakpoint.SMALL} {
    border-radius: 10px;
    box-shadow: ${SHADOW.LARGE};
    left: 0;
    max-height: 70vh;
    min-height: unset;
    padding: 24px;
    position: absolute;
    top: 67px;
    width: 400px;
  }
`;

export const LocationListPlaceholder = styled.div`
  padding: 0px;
`;

export const LocationListItem = styled.li`
  background-color: ${propSwitch('aria-selected', ThemeColours.mono100, 'none')};
  border-radius: ${BorderRadius.SMALL};
  list-style: none;
  padding: 12px 4px;

  &:hover {
    background-color: ${ThemeColours.mono100};
    cursor: pointer;
  }
`;
